//
//
//
//
//
//

import { mapGetters, mapActions } from 'vuex'
import api from '@/api'
import {isWechat, isIOS} from '@/tools/device'
import { getQuery } from '@/tools/util'
import wx from 'weixin-js-sdk'

export default {
  name: 'app',
  components: {
    getQuery
  },
  mounted () {
    window['getToken'] = (res) => {
      if (res && res !== 'null') {
        this.saveToken({token: res})
      } else {
        this.doLogout()
      }
    }
  },
  data () {
    return {
      homeShow: false,
      data: null,
      inds: 2
    }
  },
  computed: {
    ...mapGetters({
      isLoggedin: 'isLoggedin',
      querys: 'query',
      is_app: 'is_app'
    })
  },
  created () {
    this.getAppToken()
    // this.initCurrentUrl()
    // 每隔24小时微信自动进行强制登录
    // var lodTime = window.localStorage.getItem('lodtime')
    // var date = new Date().getTime()
    // if (date - lodTime > 86400000) {
    //   window.localStorage.setItem('lodtime', date)
    //   this.initWechatLogins()
    // } else {
    //   this.initWechatLogin()
    // }
    // this.initWechatLogin()
  },
  methods: {
    ...mapActions([
      'saveToken',
      'doLogout'
    ]),
    getAppToken () {
      var u = navigator.userAgent
      var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      const webBean = {
        success: 'getToken',
        fail: null,
        params: null
      }
      const str = JSON.stringify(webBean)
      if (isiOS) {
        try {
          window.webkit.messageHandlers.getUserToken.postMessage(webBean)
        } catch (err) {}
      } else {
        try {
          window.wfc.getUserToken(str)
        } catch (err) {}
      }
    },

    // 初始化入口地址，用于微信分享
    initCurrentUrl () {
      if (isWechat() && isIOS()) window.sessionStorage.setItem('initUrl', window.location.href)
      var url = window.sessionStorage.getItem('initUrl') || window.location.href
      this.axios.post(api.rv.wxcode, {url: url})
      .then(response => {
        if (response.data.code === 200) {
          wx.config({
            debug: false,
            appId: response.data.data.appid,
            timestamp: response.data.data.timestamp,
            nonceStr: response.data.data.noncestr,
            signature: response.data.data.signature,
            jsApiList: [
              'onMenuShareAppMessage',
              'onMenuShareTimeline'
            ]
          })
        }
      })
    },

    // 微信登录
    initWechatLogin () {
      var ua = window.navigator.userAgent.toLowerCase()
      if (!this.isLoggedin) {
        if (ua.indexOf('micromessenger') > 0) {
          var url = window.location.href
          if (url.indexOf('code=') > 0) {
            this.axios.post(api.user.wechatLogin, {code: getQuery(url, 'code')})
            .then(response => {
              this.saveToken({ token: response.headers.authorization })
            })
          } else if (url.indexOf('code=') < 0) {
            var urls = window.location.href
            // urls = encodeURIComponent(urls.replace('/?', '?'))
            urls = encodeURIComponent(urls)
            let t = 'https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxf2d2ebedafd76a1b&redirect_uri=' + urls + '&response_type=code&scope=snsapi_userinfo&connect_redirect=1&#wechat_redirect'
            window.location.href = t
          }
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/App.vue